import { Component } from '@angular/core';
import { GuestLinkPreview } from '../../models/guest-link-preview';
import { PortalBanner } from '../../models/portal-banner.interface';
import { PolicyService } from 'src/app/services/policy.service';
import { ClaimService } from 'src/app/services/claim.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'upsc-dynamic-layout',
  templateUrl: './dynamic-layout.component.html',
  styleUrls: ['./dynamic-layout.component.scss']
})
export class DynamicLayoutComponent {

  flowType = '';
  previewModel: GuestLinkPreview = {};
  color: string = '';
  isDynamicOutage: boolean = false;
  portalBanner: PortalBanner | null = null;
  policies: any = {};
  countryLocale: string = 'en';

  constructor(private policyService: PolicyService,
    private claimService: ClaimService,
    private loginService: LoginService) {
    this.flowType = sessionStorage.getItem("flowType");
    var previewModelString = sessionStorage.getItem("previewModelString");
    if (previewModelString !== null && previewModelString.length > 3) {
      var previewModel = JSON.parse(previewModelString);
      if (previewModel !== null) {
        this.previewModel = previewModel;
        if (previewModel && previewModel.theme === 'light') {
          document.documentElement.style.setProperty('--backgroundColor', previewModel.backgroundColor);
          document.documentElement.style.setProperty('--foregroundColor', previewModel.foregroundColor);
        } else {
          document.documentElement.style.setProperty('--backgroundColor', previewModel.backgroundColor);
          document.documentElement.style.setProperty('--foregroundColor', previewModel.foregroundColor);
        }
      }
    }
  } 

  public ngOnInit() {
    let _partnerName = '';
    let partnerDetails = JSON.parse(sessionStorage.getItem('partnerDetails')!);
    if(partnerDetails){
      _partnerName = partnerDetails.partnerName;
    }
    this.getBanner(_partnerName);
  }

  private setBannerVisibility(): void {

    if (!this.portalBanner) {
      this.isDynamicOutage = false;
      return;
    }

    const now = new Date();
    const startTime = new Date(this.portalBanner.startTime);
    const endTime = new Date(this.portalBanner.endTime);

    this.isDynamicOutage =
      now >= startTime &&
      now <= endTime;
  }

  getBanner(partnerName: string) {

    const bannerDismissed = sessionStorage.getItem('portalBannerDismissed');
    if (bannerDismissed === 'true') {
      this.isDynamicOutage = false;
      return;
    }

    const cachedBanner = sessionStorage.getItem('portalBanner');

    if (cachedBanner) {
      this.portalBanner = JSON.parse(cachedBanner);
      this.setBannerVisibility();
      return;
    }

    const policyNumber = this.loginService.getPolicyDetails()?.policyNumber!;
    this.claimService
      .getPolicyBanners('SSP', policyNumber, partnerName, this.countryLocale)
      .subscribe(response => {

        const banner = response?.data?.portalBanners?.[0];

        if (banner) {

          this.portalBanner = {
            messageText: banner.messageText,
            startTime: banner.startTime,
            endTime: banner.endTime
          };

          sessionStorage.setItem(
            'portalBanner',
            JSON.stringify(this.portalBanner)
          );

          this.setBannerVisibility();
        } else {
          this.isDynamicOutage = false;
        }
      });
  }

  onBannerClosed(): void {
    this.isDynamicOutage = false;
    sessionStorage.setItem('portalBannerDismissed', 'true');
  }


}
